// api/modules/style.js
import { apiRequest } from '@/api'

export const styleApi = {
  // 获取全局款式
  getGlobal(params = {}) {
    const { search = '', categoryId = '', page = 1, pageSize = 50 } = params
    const query = new URLSearchParams()
    if (search) query.append('search', search)
    if (categoryId) query.append('categoryId', categoryId)
    if (page) query.append('page', page)
    if (pageSize) query.append('pageSize', pageSize)
    const url = `/api/global-styles${query.toString() ? '?' + query.toString() : ''}`
    return apiRequest(url)
  },

  create(data) {
    return apiRequest('/api/global-styles', {
      method: 'POST',
      body: data
    })
  },

  update(data) {
    return apiRequest('/api/global-styles', {
      method: 'PUT',
      body: data
    })
  },

  delete(id) {
    return apiRequest('/api/global-styles', {
      method: 'DELETE',
      body: { id }
    })
  },

  getCustomerStyles(customerId) {
    return apiRequest(`/api/customer-styles?customer_id=${customerId}`)
  },

  updateCustomerStyles(customerId, styleIds) {
    return apiRequest('/api/customer-styles/update', {
      method: 'POST',
      body: { customer_id: customerId, style_ids: styleIds }
    })
  },

  uploadImage(base64Data) {
    return apiRequest('/api/upload-style-image', {
      method: 'POST',
      body: { base64: base64Data }
    })
  },

  getStyleAssociations(styleId) {
    return apiRequest(`/api/styles/processes?styleId=${styleId}`)
  },

  saveStyleAssociations(data) {
    return apiRequest('/api/styles/processes/save', {
      method: 'POST',
      body: data
    })
  },

  updateSnapshot(associationId, reason) {
    return apiRequest('/api/styles/snapshots/update', {
      method: 'POST',
      body: { associationId, reason }
    })
  },

  getSnapshotHistory(associationId) {
    return apiRequest(`/api/styles/snapshots/history?associationId=${associationId}`)
  },

  // 获取款式成本变化历史
  getCostHistory(styleId) {
    return apiRequest(`/api/styles/cost-history?styleId=${styleId}`)
  },

  // ✅ 彻底删除已取消的成本历史分组（连同所有快照 + 关联）
  deleteCostHistory(data) {
    return apiRequest('/api/styles/cost-history', {
      method: 'DELETE',
      body: data,   // { associationId }
    })
  },

  getAllCustomerStyles() {
    return apiRequest('/api/customer-styles/all')
  },
}